import { RootState } from '../../../app/store';
import { createSelector, createSlice, PayloadAction } from "@reduxjs/toolkit"
import { OrderDirection } from '../../Datatable/OrderDirection';
import { QueryItem } from '../../Tonnage/models/TonnageQueryModel';
import TotalSummaryResult from '../models/TotalSummaryResult';

interface TotalSummarySearchState {
    year: number,
    totalSummaryResults: TotalSummaryResult | null,
    triggerSearch: number,
}

const initialState: TotalSummarySearchState = {
    year: new Date().getFullYear(),
    totalSummaryResults: null,
    triggerSearch: 0,
}

export const TotalSummarySearchSlice = createSlice({
    name: "TotalSummarySearch",
    initialState,
    reducers: {
        setYear: (state, action: PayloadAction<number>) => {
            state.year = action.payload;
        },
        setTotalSummaryResults: (state, action: PayloadAction<TotalSummaryResult>) => {
            state.totalSummaryResults = action.payload;
        },
        setTriggerSearch: (state, action: PayloadAction<number>) => {
            state.triggerSearch = action.payload;
        },
    }
});

export const TotalSummarySearchSelector = createSelector(
    (state: RootState) => state.totalSummarySearch,
    (data) => data
);

export const {
    setYear,
    setTotalSummaryResults,
    setTriggerSearch
} = TotalSummarySearchSlice.actions;

export default TotalSummarySearchSlice.reducer;